<template>
  <el-dialog
    :visible.sync="visible"
    title="合同明细编辑"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="dataForm"
      :rules="dataRule"
      ref="dataForm"
      label-width="120px"
    >
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="品番号：" prop="code">
            <el-input
              v-model="dataForm.code"
              placeholder="请输入品番号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="品名：" prop="name">
            <el-input
              v-model="dataForm.name"
              placeholder="请输入产品名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="尺寸：" prop="size">
            <el-input
              v-model="dataForm.size"
              placeholder="请输入尺寸"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="颜色：" prop="color">
            <el-input
              v-model="dataForm.color"
              placeholder="请输入颜色"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="SKU编号：" prop="skuCode">
            <el-input
                v-model="dataForm.skuCode"
                placeholder="请输入SKU编号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="中文品名：" prop="nameZh">
            <el-input
                v-model="dataForm.nameZh"
                placeholder="请输入中文品名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="返单号：" prop="backCount">
            <el-input
                v-model="dataForm.backCount"
                placeholder="请输入返单号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同数量：" prop="count">
            <el-input
              v-model="dataForm.count"
              placeholder="请输入合同数量"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同单价：" prop="amount">
            <el-input
              v-model="dataForm.amount"
              placeholder="请输入合同单价"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="合同总金额：" prop="skuCode">
            {{ this.totalAmount }}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="每箱入数：" prop="boxCount">
            <el-input
              v-model="dataForm.boxCount"
              placeholder="请输入每箱入数"
            ></el-input>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <template slot="footer">
      <el-button @click="cancel">{{ $t("cancel") }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{
        $t("confirm")
      }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { moneyValidator,isPositiveNumber } from "@/utils/validate";
import debounce from "lodash/debounce";
export default {
  data() {
    return {
      id: "",
      visible: false,
      dataForm: {},
    };
  },
  computed: {
    totalAmount() {
      if (!this.dataForm.count || !this.dataForm.amount) {
        return 0;
      }
      return new this.$BigNumber(this.dataForm.amount)
        .multipliedBy(this.dataForm.count)
        .toFixed(2);
    },
    dataRule() {
      return {
        name: [{ required: true, message: "请填写名称", trigger: "change" }],
        code: [{ required: true, message: "请填写品番号", trigger: "change" }],
        amount: [
          { required: true, message: "请填写单价", trigger: "change" },
          { validator: moneyValidator, trigger: "change" },
        ],
        count: [
          { required: true, message: "请填写数量", trigger: "change" },
          {
            validator: function (rule, value, callback) {
              if(value&&!isPositiveNumber(value)){
                callback(new Error("请输入正确的数量"));
              }else{
                callback();
              }
            },
            trigger: "change",
          },
        ],
        backCount: [
          {
            validator: function (rule, value, callback) {
              if(value&&!isPositiveNumber(value)){
                callback(new Error("请输入正确的数量"));
              }else{
                callback();
              }
            },
            trigger: "change",
          },
        ],
      };
    },
  },
  methods: {
    reset() {
      this.dataForm = {
        id: "",
        name: "",
        code: "",
        color: "",
        size: "",
        attr1: "",
        attr2: "",
        amount: "",
        count: "",
        boxCount: "",
        skuCode: "",
        nameZh:'',
        backCount:1,
        unit:'',
        bomList: [],
      };
      if (this.$refs["dataForm"]) {
        this.$refs["dataForm"].resetFields();
      }
    },
    init(isReset) {
      this.visible = true;
      this.$nextTick(() => {
        if (isReset) {
          this.reset();
        } else {
          this.$refs["dataForm"].clearValidate();
        }
      });
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        this.$refs["dataForm"].validate((valid) => {
          if (!valid) {
            return false;
          }
          this.$emit("change", this.$clone(this.dataForm));
          this.visible = false;
        });
      },
      1000,
      { leading: true, trailing: false }
    ),
    cancel() {
      this.visible = false;
    },
  },
};
</script>
